module.exports = __webpack_public_path__ + "static/logo-f4c7fa2067b397fa73dafa024699068f.svg";